module.exports = __webpack_public_path__ + "img/6.4f37c2d0.jpg";